import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);
